module.exports = __webpack_public_path__ + "static/img/experience-pic2.5babb87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/experience-pic2.png
// module id = TEMa
// module chunks = 0